import styled from 'styled-components'
import { Label } from 'components/generic/Input/InputErrorMessage'

export const InputHint = styled(Label)`
  color: ${({ theme }) => theme.colors.textColor};
`
